import { CampaignDocument } from '../../model/campaign'
import { AttachLinkParams } from '../models'

// Payload builders for the campaign-links stored procedures
// (spLutCampaignLinksCreate / Update / Delete). Parameters follow the links
// table's own columns — Title and Url (not the documents' FileName/FileLink);
// the domain model's fileName/fileLink carry those values.

export const buildLinkCreateParams = ({
  campaignId,
  fileName,
  url,
  countries,
  isVisible = true,
}: AttachLinkParams) => ({
  'p.CampaignId': campaignId,
  'p.Title': fileName,
  'p.Url': url,
  'p.Countries': countries.join(','),
  'p.IsVisible': isVisible ? 1 : 0,
})

export const buildLinkUpdateParams = (document: CampaignDocument) => ({
  'p.EntryId': document.entryId,
  'p.Title': document.fileName,
  'p.Url': document.fileLink,
  'p.Countries': document.countries.join(','),
  'p.IsVisible': document.isVisible ? 1 : 0,
})

export const buildLinkDeleteParams = (document: Pick<CampaignDocument, 'entryId'>) => ({
  'p.EntryId': document.entryId,
})
